import { render, staticRenderFns } from "./TrainingPlans.vue?vue&type=template&id=ada5fca0&scoped=true&"
import script from "./TrainingPlans.vue?vue&type=script&lang=js&"
export * from "./TrainingPlans.vue?vue&type=script&lang=js&"
import style0 from "./TrainingPlans.vue?vue&type=style&index=0&id=ada5fca0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada5fca0",
  null
  
)

export default component.exports